<template>
    <div class="main">
        <template v-if="dataList.length < 1">
            <div class="title">
                <img src="../assets/ai.png">
                <span>{{ title }}</span>
            </div>
        </template>
        <template v-if="dataList.length > 0">
            <div class="content" ref="content">
                <template v-for="item in dataList">
                    <template v-if="item.type == 0">
                        <div class="right">
                            <div class="data">{{ item.text }}</div>
                        </div>
                    </template>
                    <template v-if="item.type == 1">
                        <div class="left">
                            <div class="data" v-html="item.text"></div>
                            <div class="data">结果由AI生成仅供参考，详询商务请点击 <a @click="$refs.trialModal.show({ ai: true })">详情</a></div>
                        </div>
                    </template>
                </template>
                <template v-if="loading">
                    <div class="loading">思考中...</div>
                </template>
            </div>
        </template>
        <div class="search">
            <textarea placeholder="请输入您的问题或需要查询的内容" v-model="content"></textarea>
            <div>
                <template v-if="loading">
                    <img src="../assets/submit-loading.png">
                </template>
                <template v-else-if="content.trim() == ''">
                    <img src="../assets/submit-off.png">
                </template>
                <template v-else>
                    <img src="../assets/submit.png" @click="submit">
                </template>
            </div>
        </div>
        <trialModal ref="trialModal"></trialModal>
    </div>
</template>

<script>
import trialModal from "../components/trialModal"
export default {
    name: "ai",
    components: { trialModal },
    data() {
        return {
            title: '',
            url: '',
            loading: false,
            content: '',
            dataList: [],
        }
    },
    created() {
        if (this.$route.query.orgCode) {
            this.title = 'AI问数'
            this.url = 'https://api.56links.com/v1_0_0/aiq/lyt/ask'
        } else {
            this.title = 'AI查运费'
            this.url = 'https://api.56links.com/v1_0_0/aiq/web/yjcx/ask'
        }

        window.addEventListener('keyup', this.enterSearch)
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.enterSearch)
    },
    methods: {
        enterSearch(e) {
            if (e.keyCode === 13) {
                this.submit()
            }
        },
        scrollBottom() {
            this.$nextTick(() => {
                this.$refs.content.scrollTop = this.$refs.content.scrollHeight
            })
        },
        submit() {
            if (this.content.trim() == '') {
                return
            }
            if (this.loading) {
                return
            }
            this.dataList.push({
                type: 0,
                text: this.content
            })
            this.scrollBottom()
            var param = Object.assign({ userQuestion: this.content }, this.$route.query)
            this.content = ''
            this.loading = true
            this.$axios({
                method: "post",
                url: this.url,
                data: param,
            }).then((res) => {
                this.loading = false
                this.dataList.push({
                    type: 1,
                    text: (res.data.data).replaceAll('\n', '<br/>')
                })
                this.scrollBottom()
            })
        }
    }
}
</script>

<style scoped>
@media screen and (min-width: 1025px) {
    .title {
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 2rem;
        padding-top: 2rem;
    }

    .title img {
        width: .8rem;
    }

    .title span {
        font-size: .5rem;
        margin-left: .1rem;
    }

    .content {
        width: 10rem;
        height: calc(100vh - 1.4rem);
        overflow-y: auto;
        margin: auto;
        padding-top: .1rem;
    }

    .content .left {
        margin: .1rem 0;
    }

    .content .left .data {
        font-size: .16rem;
        padding: .1rem;
        background: #fcfcfc;
        border-radius: 0 .1rem .1rem .1rem;
        word-wrap: break-word;
    }

    .content .left .data a {
        cursor: pointer;
        font-size: .16rem;
        color: #428eff;
    }

    .content .right {
        display: flex;
        justify-content: flex-end;
    }

    .content .right .data {
        max-width: 70%;
        font-size: .18rem;
        padding: .1rem;
        background: #428eff;
        border-radius: .1rem;
        word-wrap: break-word;
        color: #fff;
    }

    .content .loading {
        font-size: .16rem;
        padding: .1rem 0;
    }

    .search {
        width: 10rem;
        margin: 0 auto;
        border: 1px solid #ccc;
        background: #fff;
        border-radius: .1rem;
        padding: .1rem;
    }

    .search textarea {
        width: 100%;
        resize: none;
        font-size: .2rem;
        font-family: 'simsun';
    }

    .search div {
        display: flex;
        justify-content: flex-end;
    }

    .search div img {
        width: .5rem;
    }
}

@media screen and (max-width: 1024px) {
    .title {
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 2rem;
        padding-top: 3rem;
    }

    .title img {
        width: .8rem;
    }

    .title span {
        font-size: .6rem;
        margin-left: .1rem;
    }

    .content {
        padding: .1rem .2rem 0;
        height: calc(100vh - 2.3rem);
        overflow-y: auto;
    }

    .content .left {
        margin: .1rem 0;
    }

    .content .left .data {
        font-size: .26rem;
        padding: .1rem;
        background: #fcfcfc;
        border-radius: .1rem;
        word-wrap: break-word;
    }

    .content .left .data a {
        font-size: .26rem;
        color: #428eff;
    }

    .content .right {
        display: flex;
        justify-content: flex-end;
    }

    .content .right .data {
        max-width: 70%;
        font-size: .26rem;
        padding: .1rem;
        background: #428eff;
        color: #fff;
        border-radius: .1rem;
        word-wrap: break-word;
    }

    .content .loading {
        font-size: .26rem;
        padding: .1rem 0;
    }

    .search {
        margin: 0 .2rem;
        border: 1px solid #ccc;
        border-radius: .1rem;
        padding: .1rem;
    }

    .search textarea {
        width: 100%;
        resize: none;
        font-size: .32rem;
        font-family: 'simsun';
    }

    .search div {
        display: flex;
        justify-content: flex-end;
    }

    .search div img {
        width: .7rem;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/ai.vue